module.exports = __webpack_public_path__ + "img/page-banner.507b67d5.png";